<div class="users-details-content">
  <div class="details-card">

    <!-- Header -->
    <div class="card-header">
      <div class="header-content">
        <h2>Gestión de Usuarios</h2>
        <p>Información de usuarios del sistema</p>
      </div>

      <button mat-icon-button (click)="showHelp()" matTooltip="Ayuda" class="help-button">
        <mat-icon>help_outline</mat-icon>
      </button>

      <button mat-icon-button (click)="closeDetails()" matTooltip="Cerrar detalle" class="close-button">
        <mat-icon class="close-icon">close</mat-icon>
      </button>
    </div>

    <div class="divider"></div>

    <div class="card-content">

      <!-- =====================================================
      FORMULARIO NUEVO USUARIO
      ====================================================== -->
      @if (isAddingUser) {
        <div class="user-form-container">

          <h3>Nuevo Usuario</h3>

          <form [formGroup]="userForm">

            <mat-form-field appearance="fill" class="full-width">
              <mat-label>Email</mat-label>
              <input matInput formControlName="email">
            </mat-form-field>

            <mat-form-field appearance="fill" class="full-width">
              <mat-label>Nombre</mat-label>
              <input matInput formControlName="name">
            </mat-form-field>

            <mat-form-field appearance="fill" class="full-width">
              <mat-label>Apellido</mat-label>
              <input matInput formControlName="familyName">
            </mat-form-field>

            <div class="form-buttons">
              <button mat-raised-button color="warn" (click)="cancelAddUser()">
                Cancelar
              </button>

              <button mat-raised-button color="primary"
                [disabled]="userForm.invalid"
                (click)="saveUser()">
                Guardar
              </button>
            </div>

          </form>
        </div>
      }

      <!-- =====================================================
      TABLA DE USUARIOS
      ====================================================== -->
      @if (!isAddingUser) {

        <h3>Usuarios del sistema</h3>

        <!-- Checkboxes para seleccionar columnas -->
        <div class="column-selectors">
          <mat-checkbox class="white-text" [(ngModel)]="showEmail" (change)="onShowEmailChange()">Mostrar Correo</mat-checkbox>
          <mat-checkbox class="white-text" [(ngModel)]="showName" (change)="onShowNameChange()">Mostrar Nombre</mat-checkbox>
        </div>

        <div class="users-table-wrapper">

          <table mat-table [dataSource]="dataSource" class="users-table mat-elevation-z1">

            <!-- Email -->
            @if (showEmail) {
              <ng-container matColumnDef="email">
                <th mat-header-cell *matHeaderCellDef>Correo</th>
                <td mat-cell *matCellDef="let user" data-label="Correo">
                  {{ user.email }}
                </td>
              </ng-container>
            }

            <!-- Nombre Completo -->
            @if (showName) {
              <ng-container matColumnDef="fullName">
                <th mat-header-cell *matHeaderCellDef>Nombre</th>
                <td mat-cell *matCellDef="let user" data-label="Nombre Completo">
                  {{ user.name }} {{ user.familyName }}
                </td>
              </ng-container>
            }

            <!-- Acciones -->
            <ng-container matColumnDef="actions">
              <th mat-header-cell *matHeaderCellDef>Acciones</th>
              <td mat-cell *matCellDef="let user" data-label="Acciones">
                <mat-slide-toggle
                  [checked]="user.active"
                  (change)="onToggleChange($event.checked, user)">
                </mat-slide-toggle>
              </td>
            </ng-container>

            <!-- Header & Rows -->
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

          </table>

          <mat-paginator
            [pageSizeOptions]="[10, 25, 50, 100]"
            [pageSize]="pageSize"
            [length]="totalUsers"
            (page)="onPageChange($event)"
            showFirstLastButtons>
          </mat-paginator>

        </div>

        <button mat-raised-button color="primary" (click)="startAddUser()" class="user-add-button">
          <mat-icon>person_add</mat-icon>
          Añadir Usuario
        </button>

      }

    </div>

  </div>
</div>
